<template>
    <div class="login-creds-page">
        <LoadingWheel class="wheel-size" />
    </div>
</template>

<script>

import { Auth } from 'aws-amplify';
import { AmplifyEventBus } from 'aws-amplify-vue';
import store from '@/store/index';

import LoadingWheel from '../components/LoadingWheel.vue';

export default {
  name: 'LoginCreds',
  data() {
    return {
      username: '',
      password: '',
    };
  },
  components: {
    LoadingWheel,
  },
  mounted() {
    this.setLoginCreds();
    this.signIn();
  },
  methods: {
    async setLoginCreds() {
      const { hash } = window.location;
      console.log('hash: ', hash);
      const params = new URLSearchParams(hash.substring(1));

      if (params.has('username') === false && params.has('password') === false) {
        this.$router.push({ name: 'Login' });
        return;
      }

      this.username = decodeURIComponent(params.get('username'));
      this.password = decodeURIComponent(params.get('password'));
    },
    async signIn() {
      try {
        this.loading = true;
        const user = await Auth.signIn(this.username, this.password);
        if (!user) {
          this.loading = false;
          return;
        } // We should do error handling here

        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.$router.push({ name: 'ChangePassword', params: { user } });
          return;
        }

        const jwt = user
          .getSignInUserSession()
          .getIdToken()
          .getJwtToken();
        store.commit('setToken', jwt);
        store.commit('setLoggedIn', true);
        localStorage.setItem('loggedIn', store.state.user.loggedIn);
        AmplifyEventBus.$emit('authState', 'signedIn');
        this.loading = false;
        this.$router.push({ name: 'Cameras' });
        store.dispatch('googleAuth/checkAuthenticatedWithGoogle');
      } catch (err) {
        this.loading = false;
        console.log(err);

        if (err.code === 'UserLambdaValidationException' || err.code === 'NotAuthorizedException') {
          this.password = '';

          this.$store.dispatch('addNotification', {
            type: 'red',
            title: 'Incorrect username or password!',
            comment: 'Try again',
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.login-creds-page {
    height: 100%;
    width: 100%;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
}

.wheel-size {
    height: 120px;
    width: 120px;
}
</style>
